const plugin = {
    install() {
        const abilities = _.clone(window.Abilities)
        window.Abilities = null

        Vue.prototype.$can = (ability) => {
            return abilities.indexOf(ability) !== -1;
        }
    }
}

Vue.use(plugin)



// WEBPACK FOOTER //
// ./resources/assets/js/abilities.js